import { Controller, useForm } from 'react-hook-form';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useMutationSetExcelExportConfig } from 'api/mutations/setExcelExportConfig.mutation';
import { useQueryGetExcelExportConfig } from 'api/queries/getExcelExportConfig.query';

import { CustomizedTextArea } from 'components/common/CustomizedTextArea/CustomizedTextArea';

import subProgramClasses from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/components/subProgramPreferences.module.scss';
import { Button } from 'components/DesignSystem/Button';
import { Checkbox } from 'components/DesignSystem/Checkbox';

import classes from './ExcelExport.module.scss';

interface IFields {
    remainingDurationInDays?: boolean;
    submittedDurationComplete?: boolean;
    userData?: string;
}

export const ExcelExport = () => {
    const { contract } = useProjectTreeStore();
    const { data: excelExportConfigData, refetch } = useQueryGetExcelExportConfig({ subProgramId: contract?.id });
    const { mutate, isLoading } = useMutationSetExcelExportConfig();
    const { handleSnackBar } = useCustomSnackBar();

    const {
        control,
        handleSubmit,
        formState: { isDirty },
        reset,
    } = useForm<IFields>({
        values: {
            remainingDurationInDays: excelExportConfigData?.isExtractRemainingDuration ?? false,
            submittedDurationComplete: excelExportConfigData?.isExtractPercentageComplete ?? false,
            userData: excelExportConfigData?.userData,
        },
    });

    const handleSave = (data) => {
        if (contract) {
            mutate(
                {
                    contractId: contract.id,
                    isExtractRemainingDuration: data.remainingDurationInDays,
                    isExtractPercentageComplete: data.submittedDurationComplete,
                    userData: data.userData,
                },
                {
                    onSuccess: () => {
                        handleSnackBar('Successfully updated', 'success');
                        return refetch();
                    },
                    onError: (error) => DEFAULT_ERROR({ error, handleError: handleSnackBar }),
                },
            );
        }
    };

    return (
        <form onSubmit={handleSubmit(handleSave)} className={classes.excelExportContainer}>
            <span className={subProgramClasses.title}>P6 Excel Export:</span>
            <div className={classes.container}>
                <div>Include</div>
                <div className={classes.checkBoxSection}>
                    <div className={classes.checkBoxWrapper}>
                        <Controller
                            render={({ field }) => (
                                <Checkbox
                                    {...field}
                                    checked={field.value}
                                    label={'Remaining Duration'}
                                    labelPlacement={'end'}
                                />
                            )}
                            name={'remainingDurationInDays'}
                            control={control}
                        />
                    </div>
                    <div className={classes.checkBoxWrapper}>
                        <Controller
                            render={({ field }) => (
                                <Checkbox
                                    {...field}
                                    checked={field.value}
                                    label={'Completed %'}
                                    labelPlacement={'end'}
                                />
                            )}
                            name={'submittedDurationComplete'}
                            control={control}
                        />
                    </div>
                </div>

                <div>P6 USERDATA</div>
                <div className={classes.textAreaWrapper}>
                    <Controller
                        render={({ field }) => <CustomizedTextArea {...field} maxLength={400} />}
                        name={'userData'}
                        control={control}
                    />
                </div>

                <div className={classes.actionButtons}>
                    <Button variant={'secondary'} onClick={reset}>
                        Cancel
                    </Button>
                    <Button type={'submit'} variant={'primary'} disabled={!isDirty} isLoading={isLoading}>
                        Save
                    </Button>
                </div>
            </div>
        </form>
    );
};
